"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var value_1 = require("../evaluator/value");
var type_1 = require("../types/type");
var util_1 = require("../evaluator/util");
var evaluationErrors_1 = require("../evaluator/evaluationErrors");
var utils_1 = require("./utils");
var __1 = require("..");
function registerLogicFunctions(context) {
    var booleanLike = { type: "union", options: [type_1.BooleanType, type_1.StringType, type_1.NumberType] };
    function convertToBoolean(value) {
        if (util_1.isBooleanValue(value)) {
            return value.value;
        }
        else if (util_1.isStringValue(value)) {
            return value.value.length > 0;
        }
        else if (util_1.isNumberValue(value)) {
            return value.value !== 0;
        }
        else {
            throw new __1.FormulaError("Cannot convert value to boolean");
        }
    }
    // Branching functions
    context.registerFunction("if", {
        invokeWithASTParameters: true,
        signature: {
            type: "fixed",
            parameters: [
                booleanLike,
                { genericIdentifier: "R", combiner: "formUnion" },
                { genericIdentifier: "R", combiner: "formUnion" },
            ],
            returns: { genericIdentifier: "R" },
        },
        invoke: function (_a, context) {
            var conditionNode = _a[0], ifTrue = _a[1], ifFalse = _a[2];
            var condition = context.evaluateFunctionParameter(0, conditionNode);
            if (convertToBoolean(condition)) {
                return context.evaluateFunctionParameter(1, ifTrue);
            }
            else {
                return context.evaluateFunctionParameter(2, ifFalse);
            }
        },
    });
    var switchInvoke = function (_a, context) {
        var inputNode = _a[0], conditions = _a.slice(1);
        var input = context.evaluateFunctionParameter(0, inputNode);
        for (var i = 0; i < conditions.length - 1; i += 2) {
            var match = context.evaluateFunctionParameter(i + 1, conditions[i]);
            if (util_1.areValuesEqual(input, match)) {
                return context.evaluateFunctionParameter(i + 2, conditions[i + 1]);
            }
        }
        if (conditions.length % 2 === 0) {
            throw new evaluationErrors_1.NotApplicableError();
        }
        else {
            return context.evaluateFunctionParameter(conditions.length, conditions[conditions.length - 1]);
        }
    };
    context.registerFunction('switch', [
        {
            invokeWithASTParameters: true,
            signature: {
                type: "variadic",
                parameters: [{ genericIdentifier: "T", combiner: "set" }],
                variadicParameters: [
                    { genericIdentifier: "T", combiner: "set" },
                    { genericIdentifier: "R", combiner: "formUnion" },
                ],
                afterVariadicParameters: [{ genericIdentifier: "R", combiner: "formUnion" }],
                returns: { genericIdentifier: "R" },
            },
            invoke: switchInvoke,
        },
        {
            invokeWithASTParameters: true,
            signature: {
                type: "variadic",
                parameters: [{ genericIdentifier: "T", combiner: "set" }],
                variadicParameters: [
                    { genericIdentifier: "T", combiner: "set" },
                    { genericIdentifier: "R", combiner: "formUnion" },
                ],
                returns: { genericIdentifier: "R" },
            },
            invoke: switchInvoke,
        },
    ]);
    context.registerFunction("ifs", {
        invokeWithASTParameters: true,
        signature: {
            type: "variadic",
            parameters: [booleanLike, { genericIdentifier: "R", combiner: "formUnion" }],
            variadicParameters: [booleanLike, { genericIdentifier: "R", combiner: "formUnion" }],
            returns: { genericIdentifier: "R" },
        },
        invoke: function (params, context) {
            for (var index = 0; index < params.length; index += 2) {
                var condition = context.evaluateFunctionParameter(index, params[index]);
                if (convertToBoolean(condition)) {
                    return context.evaluateFunctionParameter(index + 1, params[index + 1]);
                }
            }
            throw new evaluationErrors_1.NotApplicableError();
        },
    });
    context.registerFunction('iferror', [
        {
            invokeWithASTParameters: true,
            signature: {
                type: "fixed",
                parameters: [{ genericIdentifier: "R", combiner: "formUnion" }],
                returns: { genericIdentifier: "R" },
            },
            invoke: function (_a, context) {
                var node = _a[0];
                try {
                    return context.evaluateFunctionParameter(0, node);
                }
                catch (e) {
                    return value_1.Value.string("");
                }
            },
        },
        {
            invokeWithASTParameters: true,
            signature: {
                type: "fixed",
                parameters: [{ genericIdentifier: "R", combiner: "formUnion" }, { genericIdentifier: "R", combiner: "formUnion" }],
                returns: { genericIdentifier: "R" },
            },
            invoke: function (_a, context) {
                var node = _a[0], fallback = _a[1];
                try {
                    return context.evaluateFunctionParameter(0, node);
                }
                catch (e) {
                    return context.evaluateFunctionParameter(1, fallback);
                }
            },
        },
    ]);
    // Boolean logic
    context.registerFunction("not", {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.BooleanType],
            returns: type_1.BooleanType
        },
        invoke: function (_a) {
            var value = _a[0];
            return value_1.Value.boolean(util_1.isBooleanValue(value) ? !value.value : true);
        },
    });
    context.registerFunction("and", {
        invokeWithASTParameters: false,
        signature: {
            type: "variadic",
            parameters: [type_1.BooleanType],
            variadicParameters: type_1.BooleanType,
            returns: type_1.BooleanType,
        },
        invoke: function (params) {
            return value_1.Value.boolean(params.every(function (p) { return util_1.isBooleanValue(p) && p.value; }));
        },
    });
    context.registerFunction("or", {
        invokeWithASTParameters: false,
        signature: {
            type: "variadic",
            parameters: [type_1.BooleanType],
            variadicParameters: type_1.BooleanType,
            returns: type_1.BooleanType,
        },
        invoke: function (params) {
            return value_1.Value.boolean(params.some(function (p) { return util_1.isBooleanValue(p) && p.value; }));
        },
    });
    context.registerFunction("xor", {
        invokeWithASTParameters: false,
        signature: {
            type: "variadic",
            parameters: [type_1.BooleanType],
            variadicParameters: type_1.BooleanType,
            returns: type_1.BooleanType,
        },
        invoke: function (params) {
            var count = params.filter(function (p) { return util_1.isBooleanValue(p) && p.value; }).length;
            return value_1.Value.boolean(count % 2 !== 0);
        },
    });
    context.registerFunction("isblank", {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.AnyType],
            returns: type_1.BooleanType,
        },
        invoke: function (_a) {
            var value = _a[0];
            return value_1.Value.boolean(utils_1.isBlank(value));
        },
    });
    context.registerFunction("isempty", {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.AnyType],
            returns: type_1.BooleanType,
        },
        invoke: function (_a) {
            var value = _a[0];
            return value_1.Value.boolean(utils_1.isEmpty(value));
        },
    });
}
exports.default = registerLogicFunctions;
//# sourceMappingURL=logic.js.map